import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Slide } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useAlertsStyles } from './styles';

const Alerts = ({ ...props }) => {
  const { openAlert, severity, messages, mobile, onClose } = props;
  const classes = useAlertsStyles({ mobile });

  return (
    <React.Fragment>
      <Snackbar
        TransitionComponent={Slide}
        autoHideDuration={6000}
        open={openAlert}
        onClose={onClose}
      >
        <Alert
          onClose={onClose}
          className={classes.alert}
          variant="filled"
          elevation={10}
          severity={severity}
        >
          {messages}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

Alerts.propTypes = {
  severity: PropTypes.string,
  messages: PropTypes.string,
  openAlert: PropTypes.bool,
  mobile: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Alerts;
